<template>
    <input
        :id="uid"
        v-model="localValue"
        class="ui-text-input d-input"
        :class="{
            'ui-text-input_invalid': error,
            'ui-text-input_focus': hasFocus,
            'ui-text-input_has-value': localValue && localValue.length > 0,
            'ui-text-input_dark': dark,
            'ui-text-input_transparent-placeholder': !placeholder || !hasFocus,
        }"
        :type="type"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :pattern="pattern"
        :readonly="readonly"
        :autocomplete="autocomplete"
        @focus="$emit('focus'), hasFocus = true"
        @blur="$emit('blur'), hasFocus = false"
        @change="onChange"
    >
</template>
<script>
export default {
    name: 'UiTextInput',
    props: {
        modelValue: String,
        id: String,
        dark: Boolean,
        /**
         * @type {'text' | 'email' | 'tel' | 'password'}
         */
        type: {
            type: String,
            default: 'text',
        },
        disabled: Boolean,
        name: String,
        error: Boolean,
        placeholder: String,
        pattern: String,
        lazy: Boolean,
        readonly: Boolean,
        autocomplete: String,
    },
    data() {
        return {
            localValue: '',
            hasFocus: false,
        };
    },
    computed: {
        uid() {
            return this.id ?? `ui-text-input-${this._uid}`;
        },
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(val) {
                this.localValue = val;
            },
        },
        localValue(val) {
            if (val !== this.modelValue && !this.lazy) this.$emit('update:modelValue', val);
        },
    },
    methods: {
        onChange() {
            if (this.lazy) this.$emit('update:modelValue', this.localValue);
        },
    },
};
</script>
<style lang="scss">
@import '/local/templates/redesign/src/assets/scss/base/_variables';
@import '/local/templates/redesign/src/assets/scss/base/_functions';
@import '/local/templates/redesign/src/assets/scss/base/_mixins';

/**
 * TODO: вынести сюда все стили
 */
.ui-text-input {
    --bg-color: #{$white-101};
    --text-color: unset;
    --border-color: #{$gray-light-hover};
    --border-color-active: #{$grey-517};
    --border-color-datepicker: #{$grey-166};
    --bg-color-invalid: #{$white-101};
    --text-color-invalid: unset;
    --border-color-invalid: #{$red-241};
    --placeholder-color: #{$grey-284};

    background: var(--bg-color);
    color: var(--text-color);
    border: 1px solid var(--border-color);

    &::placeholder {
        transition: color .2s;
    }

    &_transparent-placeholder {
        &::placeholder {
            color: transparent;
        }
    }

    &:hover {
        background: var(--bg-color);
        border: 1px solid var(--border-color-active);
    }

    &:focus, &_focus {
        border: 1px solid var(--border-color-active);
    }

    &_dark {
        --bg-color: #{$grey-868};
        --text-color: #{$grey-134};
        --border-color: #{$grey-517};
        --border-color-active: #{$grey-517};
        --bg-color-invalid: #{$grey-868};
        --border-color-invalid: #{$error-red};
        --text-color-invalid: #{$grey-134};
        --placeholder-color: #{$grey-134};
    }

    &_invalid, &_invalid:hover, &_invalid:focus {
        background: var(--bg-color-invalid);
        color: var(--text-color-invalid);
        border: 1px solid var(--border-color-invalid);
    }

    &:-webkit-autofill {
		-webkit-box-shadow: inset 0 0 0 4vw var(--bg-color)!important;
        -webkit-text-fill-color: var(--text-color)!important;
        -webkit-background-clip: text;
    }

    &_focus::placeholder {
        color: var(--placeholder-color);
    }

    &_datepicker {
        border: 1px solid var(--border-color-datepicker);

        &::placeholder {
            color: var(--placeholder-color);
        }
    }
}
</style>
